var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 438.292,
    height: 254.176,
    viewBox: "0 0 438.292 254.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4796",
    "data-name": "Path 4796",
    d: "M390.046,235.943a111.952,111.952,0,1,1-223.9,0c0-15.235-33.8-59.688-33.8-59.688s-12.063-67.937,5.465-80.135c17.959-12.5,116.542,27.873,140.284,27.873A111.949,111.949,0,0,1,390.046,235.943Z",
    transform: "translate(-97.142 92.879)",
    fill: "#09f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005cb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002e5d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3392",
    "data-name": "Group 3392",
    transform: "translate(-508.967 -279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3369",
    "data-name": "Group 3369",
    transform: "translate(508.967 316.702)",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4628",
    "data-name": "Path 4628",
    d: "M205.128,159.094H87.378c-15.084,0-18.723-21.12-4.477-26.075.182-.062.365-.125.549-.184C67.693,119.7,102.27,92.02,139.826,130.349c-2.926-12.779,30.456-8.163,40.669,9.276C184.123,128.176,215.959,148.066,205.128,159.094Z",
    transform: "translate(230.927 -63.27)",
    fill: "#def2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4629",
    "data-name": "Path 4629",
    d: "M399.541,117.374h-70.6s-16.556-6.236-14.415-22.75,27.136-2.754,27.136-2.754-7.577-23.041,16.628-16.5,26.565,29.381,26.565,29.381S416.647,99.2,399.541,117.374Z",
    transform: "translate(-278.427 -74.198)",
    fill: "#def2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4630",
    "data-name": "Path 4630",
    d: "M421.871,149.782h-46.61s-10.93-4.117-9.517-15.02,17.915-1.818,17.915-1.818-5-15.212,10.979-10.9a23.651,23.651,0,0,1,17.538,19.4S433.165,137.781,421.871,149.782Z",
    transform: "translate(-365.618 -60.153)",
    fill: "#def2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_70",
    "data-name": "Mask Group 70",
    transform: "translate(546.971 92.4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3391",
    "data-name": "Group 3391",
    transform: "translate(-3.901 -23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3390",
    "data-name": "Group 3390",
    transform: "translate(-93.241 89.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4755",
    "data-name": "Path 4755",
    d: "M390.046,235.943A111.952,111.952,0,1,1,278.093,123.994,111.951,111.951,0,0,1,390.046,235.943Z",
    transform: "translate(0 26)",
    fill: "#09f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3389",
    "data-name": "Group 3389",
    transform: "translate(117.363 77.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(175.615 159.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3370",
    "data-name": "Group 3370",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4756",
    "data-name": "Path 4756",
    d: "M172.335,168.086l-.074.042,0,0C172.289,168.116,172.31,168.1,172.335,168.086Z",
    transform: "translate(-172.261 -168.086)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3371",
    "data-name": "Group 3371",
    transform: "translate(71.026 85.997)",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4757",
    "data-name": "Path 4757",
    d: "M276.139,155.968l-6.267-3.147s.813-8.656-6.691-11.322-10.038,5.9-10.038,5.9-5.2-3.94-9.455,2.1c0,0-6.445-2.823-10.345,4.735l-9.414,3.132Z",
    transform: "translate(-148.075 -140.986)",
    fill: "#33caff",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4758",
    "data-name": "Path 4758",
    d: "M322.016,275.423l-6.265-3.149s.812-8.654-6.691-11.32-10.038,5.9-10.038,5.9-5.2-3.942-9.457,2.1c0,0-6.443-2.824-10.345,4.735l-9.414,3.132Z",
    transform: "translate(-123.42 -76.789)",
    fill: "#33caff",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4759",
    "data-name": "Path 4759",
    d: "M174.591,229.049l9.3-4.675s-1.207-12.851,9.935-16.809,14.9,8.759,14.9,8.759,7.727-5.851,14.041,3.121c0,0,9.567-4.193,15.36,7.031l13.978,4.649Z",
    transform: "translate(-174.591 -105.616)",
    fill: "#33caff",
    opacity: 0.48
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mailbox",
    transform: "translate(93.673 96.366)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3386",
    "data-name": "Group 3386",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3373",
    "data-name": "Group 3373",
    transform: "translate(110.631 257.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3372",
    "data-name": "Group 3372",
    transform: "translate(0 7.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4760",
    "data-name": "Path 4760",
    d: "M229.787,367.75c6.75,3.9,6.749,10.215,0,14.113s-17.693,3.9-24.443,0-6.75-10.215,0-14.113S223.037,363.853,229.787,367.75Z",
    transform: "translate(-200.281 -364.828)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 34.568,
    height: 7.899,
    transform: "translate(0 2.08)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4761",
    "data-name": "Path 4761",
    d: "M229.787,360.035c6.75,3.9,6.749,10.215,0,14.113s-17.693,3.9-24.443,0-6.75-10.215,0-14.113S223.037,356.138,229.787,360.035Z",
    transform: "translate(-200.281 -357.113)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3374",
    "data-name": "Group 3374",
    transform: "translate(119.776 116.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4762",
    "data-name": "Path 4762",
    d: "M223.107,361.751c3.178,1.835,3.178,4.809,0,6.645a12.721,12.721,0,0,1-11.509,0c-3.178-1.835-3.178-4.81,0-6.645A12.715,12.715,0,0,1,223.107,361.751Z",
    transform: "translate(-209.214 -216.045)",
    fill: "#004097"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 16.277,
    height: 149.029,
    fill: "#004097"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3375",
    "data-name": "Group 3375",
    transform: "translate(127.915 116.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4763",
    "data-name": "Path 4763",
    d: "M216.16,361.751a5.227,5.227,0,0,1,0,6.645,3.7,3.7,0,0,1-5.754,0,5.227,5.227,0,0,1,0-6.645A3.7,3.7,0,0,1,216.16,361.751Z",
    transform: "translate(-209.214 -216.045)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 8.138,
    height: 149.029,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3382",
    "data-name": "Group 3382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3380",
    "data-name": "Group 3380",
    transform: "translate(43.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4764",
    "data-name": "Path 4764",
    d: "M140.607,219.8V165.91l57.053-32.62,5.14,49.82Z",
    transform: "translate(-135.464 -104.236)",
    fill: "#005cb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4765",
    "data-name": "Path 4765",
    d: "M140.607,219.8V165.91l57.053-32.62,5.14,49.82Z",
    transform: "translate(-135.464 -105.412)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4766",
    "data-name": "Path 4766",
    d: "M140.607,218.635,202.8,181.949v58.642l-12.862,6.526Z",
    transform: "translate(-135.464 -104.251)",
    fill: "#005cb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4767",
    "data-name": "Path 4767",
    d: "M140.607,218.635,202.8,181.949v58.642l-12.862,6.526Z",
    transform: "translate(-134.288 -105.427)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3376",
    "data-name": "Group 3376",
    transform: "translate(7.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4768",
    "data-name": "Path 4768",
    d: "M285.438,153.289l-5.9,3.244-35.893,19.653-6.488,3.56-44.867,24.572c-2.844-4.813-10.248-27.257-14.176-31.323a59.755,59.755,0,0,0-12.881-10.226c-5.634-3.255-10.911-4.8-15.461-4.8a15.813,15.813,0,0,0-7.7,1.833l88.681-51.2.032-.022,1.759-1.011.02-.01c.253-.127.516-.243.78-.348s.526-.2.8-.295c.01-.01.031-.01.052-.022.263-.084.526-.168.8-.242s.578-.147.873-.211c.232-.052.464-.094.7-.137.127-.02.253-.042.38-.052.411-.063.831-.105,1.263-.137.169-.02.348-.02.516-.031.285-.011.569-.021.864-.021a25.281,25.281,0,0,1,7.33,1.179,40.135,40.135,0,0,1,8.142,3.623c.147.084.295.168.442.263C270.335,119.89,282.647,137.616,285.438,153.289Z",
    transform: "translate(-141.968 -106.062)",
    fill: "#33caff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4769",
    "data-name": "Path 4769",
    d: "M142.044,158.562l-.074.042,0,0C142,158.593,142.019,158.575,142.044,158.562Z",
    transform: "translate(-141.97 -104.809)",
    fill: "#33caff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377",
    transform: "translate(7.821)",
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4770",
    "data-name": "Path 4770",
    d: "M285.438,153.289l-5.9,3.244-35.893,19.653-6.488,3.56-44.867,24.572c-2.844-4.813-10.248-27.257-14.176-31.323a59.755,59.755,0,0,0-12.881-10.226c-5.634-3.255-10.911-4.8-15.461-4.8a15.813,15.813,0,0,0-7.7,1.833l88.681-51.2.032-.022,1.759-1.011.02-.01c.253-.127.516-.243.78-.348s.526-.2.8-.295c.01-.01.031-.01.052-.022.263-.084.526-.168.8-.242s.578-.147.873-.211c.232-.052.464-.094.7-.137.127-.02.253-.042.38-.052.411-.063.831-.105,1.263-.137.169-.02.348-.02.516-.031.285-.011.569-.021.864-.021a25.281,25.281,0,0,1,7.33,1.179,40.135,40.135,0,0,1,8.142,3.623c.147.084.295.168.442.263C270.335,119.89,282.647,137.616,285.438,153.289Z",
    transform: "translate(-142.074 -106.062)",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4771",
    "data-name": "Path 4771",
    d: "M142.044,158.562l-.074.042,0,0C142,158.593,142.019,158.575,142.044,158.562Z",
    transform: "translate(-111.55 -104.809)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3378",
    "data-name": "Group 3378",
    transform: "translate(58.035 28.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4772",
    "data-name": "Path 4772",
    d: "M275.04,133.96l-.009.005c.077.131.16.26.237.391C275.191,134.224,275.118,134.091,275.04,133.96Z",
    transform: "translate(-189.115 -133.96)",
    fill: "#33caff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4773",
    "data-name": "Path 4773",
    d: "M281.763,143.5a49.729,49.729,0,0,1,2.505,8.894l-5.9,3.244-35.894,19.653-6.488,3.56-44.867,24.572h0l0,0,3.933,55.555,89.83-51.9V158.841A43.794,43.794,0,0,0,281.763,143.5Z",
    transform: "translate(-191.117 -133.732)",
    fill: "#33caff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4774",
    "data-name": "Path 4774",
    d: "M278.377,140.419c-.378-.845-.78-1.686-1.2-2.525C277.6,138.733,278,139.574,278.377,140.419Z",
    transform: "translate(-189.063 -133.866)",
    fill: "#33caff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4775",
    "data-name": "Path 4775",
    d: "M275.656,135.037q.659,1.17,1.268,2.353Q276.317,136.207,275.656,135.037Z",
    transform: "translate(-189.1 -133.934)",
    fill: "#33caff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4776",
    "data-name": "Path 4776",
    d: "M279.642,143.472c-.35-.915-.73-1.829-1.131-2.741C278.912,141.643,279.293,142.557,279.642,143.472Z",
    transform: "translate(-189.032 -133.798)",
    fill: "#33caff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3379",
    "data-name": "Group 3379",
    transform: "translate(58.035 28.564)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M275.04,133.96l-.009.005c.077.131.16.26.237.391C275.191,134.224,275.118,134.091,275.04,133.96Z",
    transform: "translate(-189.115 -133.96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M281.763,143.5a49.729,49.729,0,0,1,2.505,8.894l-5.9,3.244-35.894,19.653-6.488,3.56-44.867,24.572h0l0,0,3.933,55.555,89.83-51.9V158.841A43.794,43.794,0,0,0,281.763,143.5Z",
    transform: "translate(-191.117 -133.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4779",
    "data-name": "Path 4779",
    d: "M278.377,140.419c-.378-.845-.78-1.686-1.2-2.525C277.6,138.733,278,139.574,278.377,140.419Z",
    transform: "translate(-189.063 -133.866)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4780",
    "data-name": "Path 4780",
    d: "M275.656,135.037q.659,1.17,1.268,2.353Q276.317,136.207,275.656,135.037Z",
    transform: "translate(-189.1 -133.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4781",
    "data-name": "Path 4781",
    d: "M279.642,143.472c-.35-.915-.73-1.829-1.131-2.741C278.912,141.643,279.293,142.557,279.642,143.472Z",
    transform: "translate(-189.032 -133.798)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4782",
    "data-name": "Path 4782",
    d: "M191.117,202.03",
    transform: "translate(-133.082 -103.772)",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4783",
    "data-name": "Path 4783",
    d: "M149.95,163.074c3.575,0,7.831,1.367,12.311,3.953,15.084,8.708,27.826,28.583,27.826,43.4v37.29l-49.332-28.482V174.65c0-9.568,5-11.576,9.2-11.576m0-6.319c-9.274,0-15.515,6.417-15.515,17.9v48.235l61.97,35.778V210.428c0-17.112-13.872-38.994-30.985-48.873h0c-5.633-3.252-10.918-4.8-15.471-4.8Z",
    transform: "translate(-134.435 -104.852)",
    fill: "#007adb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3381",
    "data-name": "Group 3381",
    transform: "translate(0 116.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4784",
    "data-name": "Path 4784",
    d: "M135.47,221.344,102.106,239.76a21.3,21.3,0,0,0-.376,37.1h0a61.14,61.14,0,0,0,61.11.019l34.6-19.763Z",
    transform: "translate(-91.08 -221.344)",
    fill: "#33caff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4785",
    "data-name": "Path 4785",
    d: "M135.47,221.344,102.106,239.76a21.3,21.3,0,0,0-.376,37.1h0a61.14,61.14,0,0,0,61.11.019l34.6-19.763Z",
    transform: "translate(-91.08 -221.344)",
    fill: "#33caff",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3385",
    "data-name": "Group 3385",
    transform: "translate(115.785 64.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3383",
    "data-name": "Group 3383",
    transform: "translate(3.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4786",
    "data-name": "Path 4786",
    d: "M215.312,243.5l-6.958,4.017V180.3l6.958-4.017Z",
    transform: "translate(-208.354 -168.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4787",
    "data-name": "Path 4787",
    d: "M228.457,182.3l-20.1,11.607V180.479l20.1-11.607Z",
    transform: "translate(-208.354 -168.872)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3384",
    "data-name": "Group 3384",
    transform: "translate(0 67.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4788",
    "data-name": "Path 4788",
    d: "M218.382,239.738a14.442,14.442,0,0,1-6.533,11.317c-3.608,2.083-6.533.394-6.533-3.772a14.442,14.442,0,0,1,6.533-11.317C215.456,233.882,218.382,235.572,218.382,239.738Z",
    transform: "translate(-205.315 -235.073)",
    fill: "#ff5490"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4789",
    "data-name": "Path 4789",
    d: "M218.382,239.738a14.442,14.442,0,0,1-6.533,11.317c-3.608,2.083-6.533.394-6.533-3.772a14.442,14.442,0,0,1,6.533-11.317C215.456,233.882,218.382,235.572,218.382,239.738Z",
    transform: "translate(-205.315 -235.073)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4790",
    "data-name": "Path 4790",
    d: "M220.507,240.965a14.442,14.442,0,0,1-6.533,11.317c-3.608,2.083-6.533.394-6.533-3.772a14.442,14.442,0,0,1,6.533-11.317C217.581,235.109,220.507,236.8,220.507,240.965Z",
    transform: "translate(-205.264 -235.044)",
    fill: "#ff5490"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Paper_plane",
    "data-name": "Paper plane",
    transform: "translate(31.704 58.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3388",
    "data-name": "Group 3388",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4791",
    "data-name": "Path 4791",
    d: "M159.027,192.33c-.908,0-1.829-.04-2.738-.118a.942.942,0,1,1,.16-1.878,30.024,30.024,0,0,0,3.65.091.957.957,0,0,1,.978.907.943.943,0,0,1-.907.977Q159.6,192.33,159.027,192.33Zm4.855-.393a.943.943,0,0,1-.153-1.873,26.978,26.978,0,0,0,3.545-.829.942.942,0,1,1,.552,1.8,29.1,29.1,0,0,1-3.79.888A.978.978,0,0,1,163.882,191.937Zm-11.241-.261a.935.935,0,0,1-.19-.019,33.432,33.432,0,0,1-3.744-1,.943.943,0,1,1,.592-1.79,31.225,31.225,0,0,0,3.532.944.942.942,0,0,1-.189,1.865Zm18.421-1.956a.942.942,0,0,1-.4-1.795c.219-.1.436-.209.653-.319a.942.942,0,0,1,.854,1.68q-.35.178-.7.344A.937.937,0,0,1,171.062,189.72Zm-25.563-.408a.947.947,0,0,1-.4-.087,36.316,36.316,0,0,1-3.413-1.82.942.942,0,1,1,.974-1.614,34.476,34.476,0,0,0,3.234,1.725.942.942,0,0,1-.4,1.8Zm-6.444-3.882a.94.94,0,0,1-.565-.188c-1.011-.759-2.01-1.588-2.969-2.464a.942.942,0,1,1,1.272-1.391c.914.835,1.867,1.626,2.829,2.348a.943.943,0,0,1-.566,1.7Zm-5.564-5.072a.944.944,0,0,1-.7-.306c-.854-.936-1.685-1.929-2.471-2.952a.942.942,0,1,1,1.5-1.147c.753.98,1.548,1.931,2.367,2.827a.942.942,0,0,1-.7,1.578Zm-4.583-5.972a.941.941,0,0,1-.793-.433q-.619-.96-1.187-1.948-.392-.677-.76-1.372a.943.943,0,0,1,1.666-.883c.233.442.477.881.727,1.314q.545.949,1.137,1.87a.943.943,0,0,1-.79,1.453Zm-3.529-6.653a.941.941,0,0,1-.866-.573c-.506-1.189-.958-2.4-1.346-3.613a.943.943,0,0,1,1.8-.574c.369,1.154.8,2.315,1.284,3.449a.943.943,0,0,1-.867,1.312Zm-2.29-7.171a.94.94,0,0,1-.919-.743,35.664,35.664,0,0,1-.611-3.821.942.942,0,0,1,.839-1.035.912.912,0,0,1,.391.042.941.941,0,0,1,.687-.464,22.662,22.662,0,0,0,3.529-.781.943.943,0,1,1,.554,1.8,24.6,24.6,0,0,1-3.823.846.992.992,0,0,1-.233,0c.123,1,.294,2.009.509,3.01a.942.942,0,0,1-.723,1.12A1.007,1.007,0,0,1,123.089,160.562Zm-3.242-3.908h-.01a28.111,28.111,0,0,1-3.885-.314.942.942,0,1,1,.281-1.863,26.253,26.253,0,0,0,3.624.293.943.943,0,0,1-.01,1.885Zm-7.435-1.107a.911.911,0,0,1-.259-.037,31.464,31.464,0,0,1-3.661-1.3.943.943,0,0,1,.74-1.734,29.437,29.437,0,0,0,3.439,1.223.942.942,0,0,1-.259,1.848Zm18.36-1.355a.942.942,0,0,1-.434-1.779,15.178,15.178,0,0,0,2.948-1.964.942.942,0,1,1,1.23,1.427,17,17,0,0,1-3.311,2.21A.94.94,0,0,1,130.772,154.192Zm-8.45-1.113h-.013a.942.942,0,0,1-.929-.955,30.363,30.363,0,0,1,.3-3.875.942.942,0,1,1,1.865.265,28.7,28.7,0,0,0-.28,3.637A.942.942,0,0,1,122.322,153.079ZM105.49,152.6a.928.928,0,0,1-.469-.127,31.979,31.979,0,0,1-3.238-2.142.943.943,0,0,1,1.134-1.506,30.082,30.082,0,0,0,3.045,2.016.943.943,0,0,1-.472,1.759Zm30.84-3.355a.933.933,0,0,1-.476-.129.943.943,0,0,1-.336-1.29,8.425,8.425,0,0,0,.681-1.463,6.508,6.508,0,0,0,.345-1.68.929.929,0,0,1,1.008-.871.941.941,0,0,1,.871,1.008,8.373,8.373,0,0,1-.446,2.169,10.26,10.26,0,0,1-.833,1.792A.943.943,0,0,1,136.33,149.246Zm-36.84-1.173a.939.939,0,0,1-.656-.267q-.319-.31-.63-.63c-.682-.7-1.35-1.455-1.983-2.235a.942.942,0,0,1,1.461-1.189c.6.737,1.231,1.448,1.877,2.112q.29.3.588.59a.943.943,0,0,1-.656,1.619Zm23.916-2.431a.928.928,0,0,1-.275-.042.942.942,0,0,1-.625-1.176,15.217,15.217,0,0,1,1.629-3.661.942.942,0,1,1,1.594,1.005,13.388,13.388,0,0,0-1.422,3.207A.942.942,0,0,1,123.407,145.642Zm-28.668-3.4a.939.939,0,0,1-.79-.429,38.08,38.08,0,0,1-1.935-3.344.942.942,0,0,1,1.676-.861,36.456,36.456,0,0,0,1.839,3.179.942.942,0,0,1-.277,1.3A.93.93,0,0,1,94.739,142.242ZM136.894,142a.942.942,0,0,1-.87-.581,5.475,5.475,0,0,0-1.958-2.493.942.942,0,1,1,1.049-1.565,7.356,7.356,0,0,1,2.65,3.336.943.943,0,0,1-.51,1.232A.933.933,0,0,1,136.894,142Zm-9.391-2.516a.942.942,0,0,1-.528-1.723,8.4,8.4,0,0,1,3.947-1.445.942.942,0,1,1,.163,1.878,6.511,6.511,0,0,0-3.054,1.128A.939.939,0,0,1,127.5,139.488Zm-36.214-3.937a.941.941,0,0,1-.874-.593c-.469-1.174-.9-2.4-1.27-3.635a.942.942,0,1,1,1.8-.545c.358,1.186.767,2.356,1.216,3.48a.942.942,0,0,1-.526,1.224A.924.924,0,0,1,91.289,135.552Zm-2.182-7.207a.944.944,0,0,1-.921-.746c-.264-1.238-.483-2.512-.654-3.785a.942.942,0,1,1,1.868-.25c.164,1.226.377,2.451.631,3.642a.946.946,0,0,1-.922,1.14Zm-1-7.466a.943.943,0,0,1-.94-.888c-.059-1.012-.088-2.036-.088-3.047q0-.395.006-.789a.962.962,0,0,1,.957-.928.942.942,0,0,1,.927.957c0,.253-.006.507-.006.76,0,.974.029,1.963.086,2.937a.943.943,0,0,1-.886,1Z",
    transform: "translate(-30.383 -68.282)",
    fill: "#99d6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4792",
    "data-name": "Path 4792",
    d: "M98.828,87.3l-5.634,24.465L31.7,98.568Z",
    transform: "translate(-31.704 -68.948)",
    fill: "#ff5490"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4793",
    "data-name": "Path 4793",
    d: "M98.828,87.3l-5.634,24.465L31.7,98.568Z",
    transform: "translate(-31.704 -68.948)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4794",
    "data-name": "Path 4794",
    d: "M31.7,98.354c-.016.009,76.558-2.074,76.558-2.074l18,27.727Z",
    transform: "translate(-31.704 -68.734)",
    fill: "#ff5490"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4795",
    "data-name": "Path 4795",
    d: "M31.7,99,98.828,87.729,83.011,69.376Z",
    transform: "translate(-31.704 -69.376)",
    fill: "#ff5490"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.db8dc9513a85b2306f269c147de7e67d.svg";
export { ForwardRef as ReactComponent };